import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import handleRedirect from '../../helpers/handleRedirect';
import * as queries from '../../lib/queries';

/**
 * Hook to validate guest user session token.
 *
 * If the user is a guest with a valid token, the validation will succeed and nothing happens.
 * However, if the user is unauthorized or the token is invalid, the validateGuestToken query
 * request will fail with a FORBIDDEN error. This error is handled in apolloClient, which will
 * redirect the user to the login page.
 */
export const useCheckGuestSession = () => {
  const [validateGuestToken, { loading, error }] = useLazyQuery(
    queries.VALIDATE_GUEST_TOKEN,
  );

  const checkGuestSession = useCallback(async () => {
    const result = await validateGuestToken();

    // Fallback redirect in case the validation returns false/null without throwing an error.
    // Primary error handling (FORBIDDEN) is done in apolloClient.
    if (!result?.data?.validateGuestToken) {
      handleRedirect(window.location.origin);
    }
  }, [validateGuestToken]);

  return {
    checkGuestSession,
    loading,
    error,
  };
};
